type ConsentEvent = CustomEvent<{ data: string[] }>;

type HandleConsent = (event: ConsentEvent) => boolean | void;

interface Tag<S extends string> {
  readonly __tag: S;
}

export type RichRelevanceConsent = boolean & Tag<"RichRelevance">;

declare global {
  interface Window {
    ebConsentQueue?: HandleConsent[];
  }
}

export default class RecoConsent {
  private static RICH_RELEVANCE_SESSION_STORAGE_KEY: "reco_recommendations_frontend_consent" =
    "reco_recommendations_frontend_consent" as const;
  private static RICH_RELEVANCE_KEY: "RICHR" = "RICHR" as const;
  private resolveConsentPresent:
    | ((
        value: RichRelevanceConsent | PromiseLike<RichRelevanceConsent>,
      ) => void)
    | undefined;
  private readonly consentPresent: Promise<RichRelevanceConsent>;

  constructor() {
    this.consentPresent = new Promise<RichRelevanceConsent>((resolve) => {
      this.resolveConsentPresent = resolve;
    });
  }
  setupQueue(): void {
    if (typeof window !== "undefined") {
      window.ebConsentQueue = window.ebConsentQueue || [];
      window.ebConsentQueue.push(this.handleConsentEvent.bind(this));
    }
  }

  getRichRelevanceConsent(): Promise<RichRelevanceConsent> {
    try {
      const storedConsent = sessionStorage.getItem(
        RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
      );
      if (storedConsent !== null && this.resolveConsentPresent !== undefined) {
        this.resolveConsentPresent(
          (storedConsent === "true") as RichRelevanceConsent,
        );
      }
      // eslint-disable-next-line sonarjs/no-ignored-exceptions
    } catch (_) {
      if (this.resolveConsentPresent !== undefined) {
        this.resolveConsentPresent(false as RichRelevanceConsent);
      }
    }
    return this.consentPresent;
  }

  private storeConsentInSessionStorage(
    consentGiven: RichRelevanceConsent,
  ): void {
    try {
      sessionStorage.setItem(
        RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
        `${consentGiven}`,
      );
      // eslint-disable-next-line no-empty, sonarjs/no-ignored-exceptions
    } catch (_) {}
  }

  private handleConsentEvent(event: ConsentEvent): void {
    const consentGiven = event.detail.data.includes(
      RecoConsent.RICH_RELEVANCE_KEY,
    ) as RichRelevanceConsent;
    this.storeConsentInSessionStorage(consentGiven);
    if (this.resolveConsentPresent !== undefined) {
      this.resolveConsentPresent(consentGiven);
    }
  }
}
